import { apiClient } from "../api";
import { CreateServiceDto, Service, UpdateServiceDto } from "../generated/client";

export const createService = async (data: CreateServiceDto) : Promise<Service> => {
    try {
        const response = await apiClient.services.create(data);
        return response.data;
    } catch (error) {
        console.error("create service:", error);
        throw error;
    }
};

export const getAllServices = async () : Promise<Array<Service>> => {
    try {
        const response = await apiClient.services.findAll();
        return response.data;
    } catch (error) {
        console.error("fetch service:", error);
        throw error;
    }
};

export const getServiecById = async (id: string): Promise<Service> => {
    try {
        const response = await apiClient.services.findOne(id);
        return response.data;
    } catch (error) {
        console.error(`fetch service by ID ${id}:`, error);
        throw error;
    }
};

export const updateService = async (id: string, data: UpdateServiceDto): Promise<Service> => {
    try {
        const response = await apiClient.services.update(id, data);
        return response.data;
    } catch (error) {
        console.error(`update service by ID ${id}:`, error);
        throw error;
    }
};

export const removeService = async (id: string): Promise<void> => {
    try {
        await apiClient.services.remove(id);
    } catch (error) {
        console.error(`removing service by ID ${id}:`, error);
        throw error;
    }
};
